import React, { useEffect, useRef, useState } from 'react';
import { Marker } from 'react-leaflet';

// LIVEKARTE-UBER-001 — Gleitendes Karten-Auto (gleich wie im Partnerportal).
// Die Position wandert in ~0,9 s zur neuen Koordinate statt zu springen. react-leaflet setzt
// `position` erst am Ende (dann steht das Auto schon dort); dazwischen führt dieser Baustein den
// Leaflet-Marker selbst. Ohne echtes Leaflet (Tests) springt es direkt.
export const GLIDE_MS = 900;

export default function GlidingMarker({ position, icon, eventHandlers, children }) {
  const markerRef = useRef(null);
  const rafRef = useRef(null);
  const [shown, setShown] = useState(position);
  useEffect(() => {
    const marker = markerRef.current;
    const same = shown && Math.abs(shown.lat - position.lat) < 1e-9 && Math.abs(shown.lng - position.lng) < 1e-9;
    if (same) return undefined;
    if (!marker || typeof marker.setLatLng !== 'function' || typeof marker.getLatLng !== 'function'
      || typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
      setShown(position);
      return undefined;
    }
    const from = marker.getLatLng();
    const start = performance.now();
    const step = (now) => {
      const k = Math.min(1, (now - start) / GLIDE_MS);
      const e = 1 - Math.pow(1 - k, 3);   // ease-out
      marker.setLatLng([from.lat + (position.lat - from.lat) * e, from.lng + (position.lng - from.lng) * e]);
      if (k < 1) rafRef.current = window.requestAnimationFrame(step);
      else { rafRef.current = null; setShown(position); }
    };
    if (rafRef.current) window.cancelAnimationFrame(rafRef.current);
    rafRef.current = window.requestAnimationFrame(step);
    return () => { if (rafRef.current) { window.cancelAnimationFrame(rafRef.current); rafRef.current = null; } };
  }, [position.lat, position.lng]);
  return (
    <Marker ref={markerRef} position={[shown.lat, shown.lng]} icon={icon} eventHandlers={eventHandlers}>
      {children}
    </Marker>
  );
}

// Linie wie beim Marktführer: zum Kunden → Auto→Abholort · mit Fahrgast → Auto→Ziel (durchgezogen).
// „Angekommen" steht am Abholort: Ziel-Marke + geplanter Abschnitt zum Ziel.
// `kind` ist die Linienart des Farbvertrags (Owner 19.09.2026, LiveMap.js LINE_STYLE):
//   'pickup'  = zum Abholort (blau) · 'dropoff' = zum Ziel mit Fahrgast (grün) ·
//   'planned' = zum Ziel, noch nicht gefahren (grün, gepunktet + heller).
export function rideGeometry(ride, pos, phase) {
  if (!ride || !pos) return null;
  const hasPickup = Number.isFinite(ride.pickup_lat) && Number.isFinite(ride.pickup_lng);
  const hasDropoff = Number.isFinite(ride.dropoff_lat) && Number.isFinite(ride.dropoff_lng);
  const car = [pos.lat, pos.lng];
  if (phase === 'pickup' && ride.status === 'accepted' && hasPickup) {
    return { line: [car, [ride.pickup_lat, ride.pickup_lng]], kind: 'pickup', dashed: true, pickup: hasPickup, dropoff: hasDropoff };
  }
  if (hasDropoff) {
    const unterwegs = ride.status === 'in_progress';
    return { line: [car, [ride.dropoff_lat, ride.dropoff_lng]], kind: unterwegs ? 'dropoff' : 'planned', dashed: !unterwegs, pickup: !unterwegs && hasPickup, dropoff: true };
  }
  return { line: null, kind: null, dashed: false, pickup: hasPickup, dropoff: false };
}
